import Image from 'next/image'

export default function CategoryButton(props: { name: string; image: string; active: boolean }) {
  return (
    <div className="m-1">
      {props.active ? (
        <div className="rounded-lg bg-[#EADF00] items-center justify-center">
          <div className="card-body items-center text-center p-2 m-0">
            <div className="card bg-white flex items-center w-20 h-20 p-2">
              <Image width={50} height={50} src={props.image} alt="title" className="rounded-xl text-white h-full" />
            </div>
            <p className="text-center text-black">{props.name}</p>
          </div>
        </div>
      ) : (
        <div className="items-center justify-center">
          <div className="card-body items-center text-center p-1 m-0">
            <Image width={50} height={50} src={props.image} alt="title" className="invert rounded-md h-16" />
            <p className="text-center text-white">{props.name}</p>
          </div>
        </div>
      )}
    </div>
  )
}
